import * as posActions from "./posActions";
import AsyncInterval from "./AsyncInterval";
import describeNetworkError from "./describeNetworkError";
import logger from "./sentryLogger";
import {useState, useEffect, useRef} from "react";
import {useAppDispatch} from "./hooks";

const REFRESH_DELAY = 10000; // 10 seconds

export default function useRefreshPendingOrders(
    enabled: boolean,
    pendingOrderType: "drive_thru" | "kiosk",
    training = false,
    refreshDelayMS = REFRESH_DELAY,
) {
    const dispatch = useAppDispatch();
    const [initialErrorMessage, setInitialErrorMessage] = useState("");

    const firstExecution = useRef(true);

    useEffect(() => {
        function refreshDriveThruPendingOrders() {
            const refreshFunc =
                pendingOrderType === "drive_thru"
                    ? posActions.getDriveThruPendingOrders
                    : posActions.getKioskPendingOrders;
            return dispatch(refreshFunc(training))
                .catch((err) => {
                    const description = describeNetworkError(err).join("\n");
                    logger.error("Failed to refresh pending orders.", {
                        errorMessage: description,
                        pendingOrderType: pendingOrderType,
                    });

                    if (firstExecution.current) {
                        setInitialErrorMessage(description);
                    }
                })
                .finally(() => {
                    if (firstExecution.current) {
                        firstExecution.current = false;
                    }
                });
        }

        let interval: AsyncInterval | undefined = undefined;
        if (enabled) {
            interval = new AsyncInterval(
                refreshDriveThruPendingOrders,
                refreshDelayMS,
            );
        }

        return () => {
            interval?.cancel();
        };
    }, [enabled, pendingOrderType, training]);

    function closeInitialErrorMessage() {
        setInitialErrorMessage("");
    }

    return {initialErrorMessage, closeInitialErrorMessage};
}
